/// <reference path='../../../../typings/hibachiTypescript.d.ts' />
/// <reference path='../../../../typings/tsd.d.ts' />


class OrderPayment{
    constructor(){

    }
}
export {
    OrderPayment
}